<template>
  <div>
    <card-minimal-title :title="`${total_forms} forms`"></card-minimal-title>
    <table-list class="overflow-all">
      <tr class="header">
        <th class="w-50p w-md-50p">Form</th>
        <th class="w-50p w-md-50p">Broadcast</th>
        <th class="w-25p sortable" :data-sorting-on="true" :data-sorting-direction="direction" @click="changeDirection">Created</th>
      </tr>
      <template v-if="forms && forms.length > 0">
        <a
          :href="`/form/${form.id}`"
          :key="form.id"
          @click.prevent="handleLink($event, `/form/${form.id}`)"
          v-for="form in forms"
        >
          <td class="strong w-50p w-md-50p ellipsis">
            <div class="blue">{{ form.title }}</div>
          </td>
          <td class="strong w-50p w-md-50p ellipsis">
            <template v-if="form.broadcast">
              <div>
                {{ form.broadcast.title }}
              </div>
            </template>
            <template v-else>
              <div class="gray">Not available</div>
            </template>
          </td>
          <td>{{ getCreatedAt(form.created_at) }}</td>
        </a>
      </template>
      <template v-else>
        <a class="empty-list">
          <td colspan="3" class="p-a-4">
            No forms
          </td>
        </a>
      </template>
    </table-list>

    <pagination :page="current_page" :maxPage="max_page" @page="paginate" class="m-t-4 m-b-2" />
  </div>
</template>

<script>

import moment from 'moment';

import TableList from '@/components/Lists/Table.vue';
import Pagination from '@/components/Lists/Pagination.vue';

export default {
  components: {
    Pagination,
    TableList,
  },
  methods: {
    /**
     * Fetch all forms available
     * @returns {Void}
     */
    async getForms() {
      const payload = {
        page: this.current_page,
        per_page: this.per_page,
        direction: this.direction,
      };

      const {
        forms,
        total,
        pagination: {
          current_page = 1,
          max_page = 1,
        } = {},
      } = await this.$store.dispatch('Forms/getAllForms', payload);

      this.forms = forms;
      this.current_page = current_page;
      this.max_page = max_page;
      this.total_forms = total;
    },
    /**
     * Update pagination
     * @param {Number} page
     * @returns {Void}
     */
    paginate(page) {
      this.current_page = page;

      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page,
        },
      });

      this.getForms();
    },
    /**
     * Change direction
     * @returns {Void}
     */
    changeDirection() {
      this.direction = this.direction === 'desc' ? 'asc' : 'desc';
      this.getForms();
    },
    /**
     * Return formated created at date
     * @returns {String}
     */
    getCreatedAt(date) {
      return Math.abs(moment().diff(date, 'days')) < 2 ? moment(date).from(moment()) : this.$options.filters.formatdate(date, 'MMM Do YYYY');
    },
  },
  data() {
    return {
      forms: [],
      current_page: 1,
      max_page: 1,
      total_forms: 0,
      direction: 'desc',
    };
  },
  mounted() {
    const {
      page = 1,
      direction = 'desc',
    } = this.$queryHelper.get();

    this.current_page = page;
    this.direction = direction;

    this.getForms();
  },
};
</script>
